module.exports = __webpack_public_path__ + "static/media/windows-xp.b586262e.jpg";